export default {
  invoices: [],
  unpaidInvoices: [],
  invoicesCount: 0
}
